import {
  getdmpconnectConnectorConfig as getdmpconnectConnectorConfigAccessor,
} from 'dmpconnectjsapp-base/helpers/accessors';
import { getAccessRightsProps } from 'dmpconnectjsapp-base/rules/accessRights';

export const getDmpconnectConnectorConfig = state => getdmpconnectConnectorConfigAccessor(state);
export const getAccessRights = state => getAccessRightsProps(state);
